export default __webpack_public_path__ + "static/media/location-b.498fca55.svg";